import css from 'styled-jsx/css';

export default css`.PcCarousel {
  display: none;
  padding: 15px 0; }
  @media (min-width: 768px) {
    .PcCarousel {
      display: block; } }
  .PcCarousel :global(~ .masonry-layout) {
    margin-top: 0; }

.grid {
  position: relative;
  display: grid;
  grid-template: 'slider slider article-1' 1fr 'slider slider article-2' 1fr 'article-3 article-4 article-5' 1fr / 1fr 1fr 1fr;
  grid-gap: 10px;
  width: 100%;
  overflow: hidden;
  margin: 0 auto; }
  @media (min-width: 576px) {
    .grid {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .grid {
      max-width: 720px; } }
  @media (min-width: 992px) {
    .grid {
      max-width: 960px; } }
  @media (min-width: 1216px) {
    .grid {
      max-width: 960px; } }

.isLoading {
  position: relative;
  overflow: hidden; }
  .isLoading > * {
    transition: opacity 0.4s;
    opacity: 0; }
  .isLoading::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 50%;
    width: 500%;
    margin-left: -250%;
    background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 46%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0) 54%) 50% 50%;
    opacity: 0.3;
    z-index: 1;
    animation: PcCarouselLoading 2s linear infinite; }

@keyframes PcCarouselLoading {
  0% {
    transform: translate3d(-30%, 0, 0); }
  100% {
    transform: translate3d(30%, 0, 0); } }

.card *,
.slider * {
  color: #fff;
  box-sizing: border-box; }

.slider {
  background: #edeef0;
  grid-area: slider;
  overflow: hidden; }
  .slider > * {
    opacity: 0;
    transition: opacity 0.4s; }

.slider {
  height: 100%;
  color: #fff; }
  .slider :global(.cover) {
    width: 100%;
    height: 100%; }
    .slider :global(.cover)::before {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3)); }
  .slider :global(.slick-slider),
  .slider :global(.slick-list),
  .slider :global(.slick-track),
  .slider :global(.slick-slide),
  .slider :global(.slick-slide > div),
  .slider :global(.slick-slide article) {
    height: 100%;
    color: #fff; }
  .slider :global(.slick-slide article) {
    width: 100%; }
  .slider :global(.slick-list .slick-slide) :global(article img) {
    transition: transform 0.4s; }
  .slider :global(.slick-list .slick-slide):global(:hover article img) {
    transform: scale(1.1); }
  .slider :global(.slick-prev),
  .slider :global(.slick-next),
  .slider :global(.slick-dots) {
    z-index: 1; }
  .slider :global(.slick-prev) {
    left: 10px; }
  .slider :global(.slick-next) {
    right: 10px; }
  .slider :global(.slick-dots) {
    bottom: 0;
    margin-bottom: 10px; }
    .slider :global(.slick-dots) :global(li.slick-active button::before) {
      background: #fff; }
    .slider :global(.slick-dots) :global(li) :global(button:focus::before),
    .slider :global(.slick-dots) :global(li) :global(button:hover::before) {
      background: #fff; }
    .slider :global(.slick-dots) :global(li) :global(button) {
      display: flex;
      justify-content: center;
      align-items: center; }
      .slider :global(.slick-dots) :global(li) :global(button)::before {
        content: '';
        position: initial;
        width: 8px;
        height: 8px;
        border: solid 1px #fff;
        border-radius: 50%;
        color: rgba(0, 0, 0, 0);
        text-shadow: 0 0 1px #fff;
        opacity: 1; }

.card {
  position: relative;
  background-color: #edeef0;
  overflow: hidden;
  cursor: pointer; }
  .card:nth-of-type(1) {
    grid-area: article-1; }
  .card:nth-of-type(2) {
    grid-area: article-2; }
  .card:nth-of-type(3) {
    grid-area: article-3; }
  .card:nth-of-type(4) {
    grid-area: article-4; }
  .card:nth-of-type(5) {
    grid-area: article-5; }
  .card .cover {
    width: 100%;
    background-image: none;
    background-color: rgba(0, 0, 0, 0.025);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transition: background-image 0.3s, transform 0.4s; }
    .card .cover::before {
      content: '';
      display: block;
      padding-top: 52.5%; }
  .card .info {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
    padding: 15px 15px 8px;
    background: rgba(0, 0, 0, 0.5);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 75%, rgba(0, 0, 0, 0) 100%);
    transform: translateY(100%) translateY(-3em) translateY(-30px);
    transition: transform 0.4s, background 0.4s;
    will-change: transform, background; }
  .card:hover .cover, .card.hover .cover {
    transform: scale(1.1); }
  .card:hover .info, .card.hover .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    padding: 12px 15px;
    transform: translateY(0); }
  .card:last-child .cover::before {
    background-color: rgba(43, 43, 43, 0.6); }
  .card:last-child .info {
    display: none; }
  .card:last-child::after {
    content: attr(data-more);
    display: inline-block;
    width: fit-content;
    position: absolute;
    top: 50%;
    left: 50%;
    color: #fff;
    outline: solid 2px #fff;
    padding: 1em 1.5em;
    transform: translate(-50%, -50%); }
`